import React from 'react';
import '@gouvfr/dsfr/dist/component/alert/alert.min.css';
import { AlerteDefaultProps } from "./AlerteMi.types";
var AlerteMi = function (_a) {
    var type = _a.type, taille = _a.taille, titre = _a.titre, ComponentTitreBalise = _a.titreAs, description = _a.description, onClose = _a.onClose, role = _a.role, className = _a.className;
    if (!ComponentTitreBalise) {
        ComponentTitreBalise = "h3";
    }
    var classAlerte = "fr-alert fr-alert--".concat(type);
    if (taille === "sm") {
        classAlerte += " fr-alert--sm";
    }
    if (className) {
        classAlerte += " ".concat(className);
    }
    return (React.createElement("div", { role: role, className: classAlerte },
        React.createElement(ComponentTitreBalise, { className: "fr-alert__title" }, titre),
        React.createElement("p", null, description),
        onClose && (React.createElement("button", { type: "button", className: "fr-link--close fr-link", onClick: onClose }, "Masquer le message"))));
};
AlerteMi.defaultProps = AlerteDefaultProps;
export default AlerteMi;
